export default __webpack_public_path__ + "static/media/advent-calendar-mask.61aabae9.png";